import { parse, parseUrl, stringifyUrl } from 'query-string';

const getCurrentQuery = () => {
  return parse(window.location.search);
};

/**
 * Объединяет query целевого url с текущими query страницы.
 * При конфликте ключей приоритет у query целевого url.
 */
export const mergeWithCurrentQuery = (targetUrl: string) => {
  const { url, query: targetQuery } = parseUrl(targetUrl);
  const currentQuery = getCurrentQuery();

  return stringifyUrl({
    url,
    query: {
      ...currentQuery,
      ...targetQuery,
    },
  });
};
